import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

const YoutubeIcon: FunctionComponent<Props> = ({
  className = "",
  fill = "",
  width = 40,
  height = 40,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Youtube</title>
      <path
        d="M33.4148 12.0057C33.0928 10.8232 32.1436 9.891 30.9396 9.57475C28.7556 9 20 9 20 9C20 9 11.2444 9 9.0604 9.57475C7.8564 9.891 6.9072 10.8232 6.5852 12.0057C6 14.1507 6 20 6 20C6 20 6 25.8492 6.5852 27.9942C6.9072 29.1767 7.8564 30.109 9.0604 30.4253C11.2444 31 20 31 20 31C20 31 28.7556 31 30.9396 30.4253C32.145 30.109 33.0928 29.1767 33.4148 27.9942C34 25.8492 34 20 34 20C34 20 34 14.1507 33.4148 12.0057ZM17.2 24.763V15.237L25.6 20L17.2 24.763Z"
        fill={fill}
      />
    </svg>
  );
};

export default YoutubeIcon;
